import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { QuotesListTableDocument } from 'generated/resources/graphql'
import { QuoteUpsertPageDocument } from 'generated/resources/graphql'
import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import UpsertSidePanel from 'modules/finance/components/Quotes/UpsertSidePanel'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const QuoteUpsertPage = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const dealId = state?.dealId
  const { navigation } = useNavigation()
  const { quoteId } = useParams()
  const {
    employee,
    company: { id: companyId },
  } = useCurrentSession()

  const { data, error, loading } = useQuery(QuoteUpsertPageDocument, {
    variables: {
      companyId,
    },
  })

  const defaultLegalEntity = employee?.legalEntity
  const defaultCurrency = defaultLegalEntity?.currency
  const defaultDate = moment().format('YYYY-MM-DD')
  const canSeeFinanceQuotesSubLevelItem =
    data?.finance._policies.sidebarSeeFinanceQuotesSubLevelItem.can
  const hasQuickQuoteBuilderFeature = !!data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_quick_quote_builder'
  )?.enabled
  // This is wrong as it is not considering permission to the current quote
  // But we wont fix it as this page will be removed soon
  const authorized = canSeeFinanceQuotesSubLevelItem && !hasQuickQuoteBuilderFeature

  const onClose = () => {
    if (dealId) {
      navigate(navigation.finance.sales.deals.dealId.quotes.fullPath({ dealId }))
    } else {
      navigate(navigation.finance.sales.quotes.fullPath())
    }
  }

  return (
    <ResponsivePage.Body
      showHeader={false}
      variant="full"
      authorized={authorized}
      loading={loading}
      error={error}
    >
      <UpsertSidePanel
        quoteId={quoteId}
        onClose={onClose}
        defaultCurrency={defaultCurrency}
        defaultDate={defaultDate}
        defaultLegalEntity={defaultLegalEntity}
        documentToRefetchOnCreate={QuotesListTableDocument}
        defaultDealId={dealId ? Number(dealId) : undefined}
      />
    </ResponsivePage.Body>
  )
}

export default QuoteUpsertPage
